import {
  featureFlags,
  featureFlagService,
} from '../../Services/FeatureFlagService';
import FeatureFlagScope from 'knock-utils/feature-flag/feature-flag-scope';

const {
  ADMIN_AFFORDABLE_LEASING,
  ADMIN_AI_AGENTS,
  ADMIN_AI_EMAIL_TRIGGER,
  ADMIN_AI_TEMPLATES,
  AI_RESPONSE_COUNTS_AS_ENGAGEMENT,
  ADMIN_ASSIGNED_MANAGER,
  ADMIN_BATCH_SOURCE_COST,
  ADMIN_BOOKS_MAPPING,
  ADMIN_BRAND_CONTENT_ENHANCEMENTS,
  ADMIN_COMPANY_TEMPLATES,
  ADMIN_COMPANY_TEMPLATES_PREVIEW,
  ADMIN_COMPANY_TEMPLATES_SELF_GUIDED_TOURS,
  ADMIN_COMPANY_TEMPLATES_WINBACK,
  ADMIN_CONFIGURABLE_STALE_TRIGGER,
  ADMIN_DOORWAY_DNI,
  ADMIN_DOORWAY_ENHANCEMENTS,
  ADMIN_DOORWAY_FEE_DISCLAIMER,
  ADMIN_DOORWAY_V2_FEE_CALCULATOR,
  ADMIN_MULTI_PHASE_PROPERTY,
  ADMIN_DRIP_SMS,
  ADMIN_ENABLE_APPLICANT_CALL_ROUTING,
  ADMIN_ENABLE_LOFT_CHAT_DEEPLINK,
  ADMIN_ENHANCED_VOICE_SETTINGS,
  ADMIN_GOOGLE_SPREADSHEET,
  ADMIN_LEASING_TEAM_TODO_THRESHOLDS,
  ADMIN_LRO_SETTINGS,
  ADMIN_MARKETING_SOURCE_COST,
  ADMIN_OMNIBAR,
  ADMIN_OMNIBAR_HELP,
  ADMIN_OMNIBAR_UNIFIED_SUPPORT,
  ADMIN_OSM_INTEGRATION,
  ADMIN_PHOTOS_MIGRATION,
  ADMIN_PROPERTIES_PAGE,
  ADMIN_PROPERTIES_TOUR_HOURS,
  ADMIN_REFORMED_SYNDICATION,
  ADMIN_REQUIRE_SHOW_UNITS,
  ADMIN_RESIDENT_DRIP_CAMPAIGN,
  ADMIN_SSDA_PAGE,
  ADMIN_TMLP,
  ADMIN_UNIFIED_AI_LEASING_SETTINGS,
  ADMIN_UNIFIED_AI_RESIDENT_SETTINGS,
  AI_EMAIL_GEN_AI_ADMIN,
  AI_NURTURE,
  CALL_INTEL_STANDALONE,
  CLAW_AI_GUESTCARD_SUMMARY,
  CLAW_INBOX_UNREAD_MESSAGE_BADGE,
  COMPANY_SOURCE_LIST,
  DISABLE_USER_DELETE,
  NEW_UNITS,
  QUOTE_UPCHARGES,
  RENTER_AI,
  RENTER_AI_RESIDENTS,
  RESIDENT_AI_NURTURE,
  RENTER_AI_RESIDENT_EMAIL,
  SHOW_NEW_VA_CONFIGURATION_UI,
  TOURS_SITE_MAP,
  USE_COOKIE_FOR_TOKEN,
} = featureFlags;

export const featureFlagConfig = {
  [ADMIN_AFFORDABLE_LEASING]: {
    isAffordableLeasingEnabled: false,
  },
  [ADMIN_AI_AGENTS]: {
    isAdminAiAgentsEnabled: false,
  },
  [ADMIN_AI_EMAIL_TRIGGER]: {
    isAiEmailTriggerEnabled: false,
  },
  [ADMIN_AI_TEMPLATES]: {
    isAiTemplatesEnabled: false,
  },
  [ADMIN_ASSIGNED_MANAGER]: {
    isAdminAssignedManagerEnabled: false,
  },
  [ADMIN_BATCH_SOURCE_COST]: {
    isBatchSourceCostEnabled: false,
  },
  [ADMIN_BOOKS_MAPPING]: {
    isBooksMappingEnabled: false,
  },
  [ADMIN_BRAND_CONTENT_ENHANCEMENTS]: {
    isEnhancedBrandContentEnabled: false,
  },
  [ADMIN_COMPANY_TEMPLATES]: {
    isCompanyTemplatesEnabled: false,
  },
  [ADMIN_COMPANY_TEMPLATES_PREVIEW]: {
    isCompanyTemplatesPreviewEnabled: false,
  },
  [ADMIN_COMPANY_TEMPLATES_SELF_GUIDED_TOURS]: {
    isCompanyTemplatesSelfGuidedToursEnabled: false,
  },
  [ADMIN_COMPANY_TEMPLATES_WINBACK]: {
    isCompanyTemplatesWinbackEnabled: false,
  },
  [ADMIN_CONFIGURABLE_STALE_TRIGGER]: {
    isConfigurableStaleTriggerEnabled: false,
  },
  [ADMIN_DOORWAY_DNI]: {
    isDoorwayDniEnabled: false,
  },
  [ADMIN_DOORWAY_ENHANCEMENTS]: {
    isDoorwayEnhancementsEnabled: false,
  },
  [ADMIN_DOORWAY_FEE_DISCLAIMER]: {
    isDoorwayFeeDisclaimerEnabled: false,
  },
  [ADMIN_DOORWAY_V2_FEE_CALCULATOR]: {
    isDoorwayV2FeeCalculatorEnabled: false,
  },
  [ADMIN_MULTI_PHASE_PROPERTY]: {
    isMultiPhasePropertyEnabled: false,
  },
  [ADMIN_DRIP_SMS]: {
    isDripSmsEnabled: false,
  },
  [ADMIN_ENABLE_APPLICANT_CALL_ROUTING]: {
    isApplicantCallRoutingEnabled: false,
  },
  [ADMIN_ENABLE_LOFT_CHAT_DEEPLINK]: {
    isLoftChatDeeplinkEnabled: false,
  },
  [ADMIN_ENHANCED_VOICE_SETTINGS]: {
    isEnhancedVoiceSettingsEnabled: false,
  },
  [ADMIN_GOOGLE_SPREADSHEET]: {
    isAdminGoogleSpreadsheetEnabled: false,
  },
  [ADMIN_LEASING_TEAM_TODO_THRESHOLDS]: {
    isLeasingTeamTodoThresholdsEnabled: false,
  },
  [ADMIN_LRO_SETTINGS]: {
    isAdminLROSettingsEnabled: false,
  },
  [ADMIN_MARKETING_SOURCE_COST]: {
    isSourcesMarketingSourceCostEnabled: false,
  },
  [ADMIN_OMNIBAR]: {
    isOmnibarEnabled: false,
  },
  [ADMIN_OMNIBAR_HELP]: {
    isOmnibarHelpEnabled: false,
  },
  [ADMIN_OMNIBAR_UNIFIED_SUPPORT]: {
    isOmnibarUnifiedSupportEnabled: false,
  },
  [ADMIN_OSM_INTEGRATION]: {
    isOSMEnabled: false,
  },
  [ADMIN_PHOTOS_MIGRATION]: {
    isAdminPhotosTabEnabled: false,
  },
  [ADMIN_PROPERTIES_PAGE]: {
    isNewPropertiesPageEnabled: false,
  },
  [ADMIN_PROPERTIES_TOUR_HOURS]: {
    isPropertiesTourHoursEnabled: false,
  },
  [RESIDENT_AI_NURTURE]: {
    isResidentAiNurtureEnabled: false,
  },
  [ADMIN_REFORMED_SYNDICATION]: {
    isReformedSyndicationEnabled: false,
  },
  [ADMIN_REQUIRE_SHOW_UNITS]: {
    isAdminRequireShowUnitsEnabled: false,
  },
  [ADMIN_RESIDENT_DRIP_CAMPAIGN]: {
    isResidentDripCampaignEnabled: false,
  },
  [ADMIN_SSDA_PAGE]: {
    isSSDAPageEnabled: false,
  },
  [ADMIN_TMLP]: {
    isFeeTransparencyEnabled: false,
  },
  [ADMIN_UNIFIED_AI_LEASING_SETTINGS]: {
    isUnifiedLeasingSettingsEnabled: false,
  },
  [ADMIN_UNIFIED_AI_RESIDENT_SETTINGS]: {
    isUnifiedResidentSettingsEnabled: false,
  },
  [AI_EMAIL_GEN_AI_ADMIN]: {
    isAiEmailGenAiAdminEnabled: false,
  },
  [AI_NURTURE]: {
    isAiNurtureEnabled: false,
  },
  [AI_RESPONSE_COUNTS_AS_ENGAGEMENT]: {
    isAiResponseCountsAsEngagementEnabled: false,
  },
  [CALL_INTEL_STANDALONE]: {
    isCallIntelStandaloneEnabled: false,
  },
  [CLAW_AI_GUESTCARD_SUMMARY]: {
    isClawAIGuestCardSummaryEnabled: false,
  },
  [CLAW_INBOX_UNREAD_MESSAGE_BADGE]: {
    isClawInboxUnreadMessageBadgeEnabled: false,
  },
  [COMPANY_SOURCE_LIST]: {
    isCompanySourceListEnabled: false,
  },
  [DISABLE_USER_DELETE]: {
    isUserDeleteDisabled: false,
  },
  [NEW_UNITS]: {
    newUnitsFlags: false,
  },
  [QUOTE_UPCHARGES]: {
    quoteUpchargesFlags: false,
  },
  [RENTER_AI]: {
    renterAIFlag: {},
  },
  [RENTER_AI_RESIDENTS]: {
    renterAIResidentsFlag: {},
  },
  [RENTER_AI_RESIDENT_EMAIL]: {
    renterAIResidentsEmailEnabledProperties: {},
  },
  [SHOW_NEW_VA_CONFIGURATION_UI]: {
    isShowNewVAConfigurationUiEnabled: false,
  },
  [TOURS_SITE_MAP]: {
    isToursSiteMapEnabled: false,
  },
  [USE_COOKIE_FOR_TOKEN]: {
    isUseCookieForTokenEnabled: false,
  },
};

export const initialFeatureFlags = [
  ADMIN_AFFORDABLE_LEASING,
  ADMIN_AI_AGENTS,
  ADMIN_AI_EMAIL_TRIGGER,
  ADMIN_AI_TEMPLATES,
  AI_RESPONSE_COUNTS_AS_ENGAGEMENT,
  ADMIN_ASSIGNED_MANAGER,
  ADMIN_BATCH_SOURCE_COST,
  ADMIN_BOOKS_MAPPING,
  ADMIN_BRAND_CONTENT_ENHANCEMENTS,
  ADMIN_COMPANY_TEMPLATES,
  ADMIN_COMPANY_TEMPLATES_PREVIEW,
  ADMIN_COMPANY_TEMPLATES_SELF_GUIDED_TOURS,
  ADMIN_COMPANY_TEMPLATES_WINBACK,
  ADMIN_CONFIGURABLE_STALE_TRIGGER,
  ADMIN_DOORWAY_DNI,
  ADMIN_DOORWAY_ENHANCEMENTS,
  ADMIN_DOORWAY_FEE_DISCLAIMER,
  ADMIN_DOORWAY_V2_FEE_CALCULATOR,
  ADMIN_MULTI_PHASE_PROPERTY,
  ADMIN_DRIP_SMS,
  ADMIN_ENABLE_APPLICANT_CALL_ROUTING,
  ADMIN_ENABLE_LOFT_CHAT_DEEPLINK,
  ADMIN_ENHANCED_VOICE_SETTINGS,
  ADMIN_GOOGLE_SPREADSHEET,
  ADMIN_LEASING_TEAM_TODO_THRESHOLDS,
  ADMIN_LRO_SETTINGS,
  ADMIN_MARKETING_SOURCE_COST,
  ADMIN_OMNIBAR,
  ADMIN_OMNIBAR_HELP,
  ADMIN_OMNIBAR_UNIFIED_SUPPORT,
  ADMIN_OSM_INTEGRATION,
  ADMIN_PHOTOS_MIGRATION,
  ADMIN_PROPERTIES_PAGE,
  ADMIN_PROPERTIES_TOUR_HOURS,
  ADMIN_REFORMED_SYNDICATION,
  ADMIN_REQUIRE_SHOW_UNITS,
  ADMIN_RESIDENT_DRIP_CAMPAIGN,
  ADMIN_SSDA_PAGE,
  ADMIN_TMLP,
  ADMIN_UNIFIED_AI_LEASING_SETTINGS,
  ADMIN_UNIFIED_AI_RESIDENT_SETTINGS,
  AI_EMAIL_GEN_AI_ADMIN,
  AI_NURTURE,
  CALL_INTEL_STANDALONE,
  CLAW_AI_GUESTCARD_SUMMARY,
  CLAW_INBOX_UNREAD_MESSAGE_BADGE,
  COMPANY_SOURCE_LIST,
  DISABLE_USER_DELETE,
  RENTER_AI,
  RENTER_AI_RESIDENTS,
  RESIDENT_AI_NURTURE,
  RENTER_AI_RESIDENT_EMAIL,
  SHOW_NEW_VA_CONFIGURATION_UI,
  TOURS_SITE_MAP,
  USE_COOKIE_FOR_TOKEN,
];

export const initializeFeatureFlagService = async (scope, companyId) => {
  return await featureFlagService.initialize(
    new FeatureFlagScope(scope, {
      company: companyId,
      service: 'knock-admin-web',
    }),
  );
};

export const getFeatureFlag = async (featureFlagName) => {
  const [flagConfig] = Object.entries(featureFlagConfig[featureFlagName]);
  const [flagKey, defaultValue] = flagConfig;
  const flagValue = await featureFlagService.get(featureFlagName, defaultValue);
  return [flagKey, flagValue];
};

export const getInitialFeatureFlags = () =>
  initialFeatureFlags.reduce(async (featureFlags, featureFlagName) => {
    const previousFeatureFlags = await featureFlags;

    const [flagKey, flagValue] = await getFeatureFlag(featureFlagName);
    previousFeatureFlags[flagKey] = flagValue;

    return previousFeatureFlags;
  }, Promise.resolve({}));
